import { useEffect, useState } from "react";

/**
 * A clock that ticks. The value is the instant, so a caller formats it as it
 * likes — the wall counts a deploy up in `mm:ss`, the dashboard in `1m 05s`.
 * Anything on screen that is still happening reads from this rather than
 * from `Date.now()` at render, which only moves when the poll does.
 */
export function useNow(everyMs = 1000) {
    const [now, setNow] = useState(() => Date.now());
    useEffect(() => {
        const timer = setInterval(() => setNow(Date.now()), everyMs);
        return () => clearInterval(timer);
    }, [everyMs]);
    return now;
}
